<template>
	<el-dialog :title="title" v-model="dialogVisible" width="30%" :before-close="handleClose">
		<el-form ref="form" :model="form" :rules="rules">
			<el-form-item label="所属学校:" prop="schoolName" label-width="100px">
				<el-select filterable v-model="form.schoolName" placeholder="请选择学校" @change="schoolClick">
					<el-option :label="item.name" :value="item.id" v-for="item in schoolList"
						:key="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="IMEI:" prop="imei" label-width="100px">
				<el-input v-model="form.imei" autocomplete="off" maxlength="18"></el-input>
			</el-form-item>
			<el-form-item label="DEVICEID:" prop="code" label-width="100px">
				<el-input v-model="form.code" autocomplete="off" maxlength="18"></el-input>
			</el-form-item>
			<el-form-item label="手机号码:" prop="mobile" label-width="100px">
				<el-input v-model="form.mobile" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="进出类型: " label-width="100px">
				<el-select v-model="form.openDoorType" placeholder="选择进出类型">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<div class="buttom-box">
				<el-button type="primary" @click="onSubmit('form')">提交</el-button>
				<el-button @click="handleClose">返回</el-button>
			</div>
		</el-form>

	</el-dialog>
</template>
<script>
	import {
		readerCardAdd,
		readerCardBaseInfo,
		readerCardUpdate
	} from '@/assets/api/schoollog'
	import { schoolList } from '@/assets/api/renyuan'
	import { ElMessage } from 'element-plus'

	export default {
		components: {},
		props: ['xiugaiObj'],
		data() {

			return {
				dialogVisible: true,
				title: '',
				form: {
					schoolName: '',
					imei: '',
					mobile: '',
					code: "",
					openDoorType:''
				},

				options: [{
						label: '仅人脸',
						value: 1
					},
					{
						label: '仅CPU卡',
						value: 2
					},
					{
						label: '通用',
						value: 3
					}
				],
				cardid: "",
				schoolList: [],
				rules: {
					imei: [{
						required: true,
						message: '请输入imei号',
						trigger: 'blur'
					}, ],
					schoolName: [{
						required: true,
						message: '请输入学校',
						trigger: 'blur'
					}, ],
					code: [{
						required: true,
						message: '请输入DEVICEID',
						trigger: 'blur'
					}, ],
				}
			}

		},
		created() {},
		mounted() {
			this.schoolPost()
			if (JSON.stringify(this.xiugaiObj) !== "{}") {
				console.log(this.xiugaiObj, '修改imei');
				this.title = '修改读卡器管理'
				const params = {
					id: this.xiugaiObj.readCardId
				}
				readerCardBaseInfo(params).then((res) => {
					this.form.code = res.data.data.code
					this.form.schoolName = res.data.data.schoolName
					this.form.mobile = res.data.data.mobile
					this.form.imei = res.data.data.name
					this.form.openDoorType = res.data.data.openDoorType
					this.cardid = res.data.data.id
					console.log(res, this.cardid, '成功');

				}).catch((err) => {
					console.log(err, '失败');

				})

			} else {
				console.log(this.xiugaiObj, '新增imei');
				this.title = '新增读卡器管理'
			}
		},
		methods: {
			handleClose() {
				this.$emit('AddShowClick')
			},
			schoolPost(schooName) {
				let params = JSON.parse(localStorage.getItem('user')).id;
				schoolList(params).then((res) => {
					// console.log(res,'学校列表');
					this.schoolList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},
			//新增
			readerCardAdditive() {
				const params = {
					code: this.form.code,
					mobile: this.form.mobile,
					name: this.form.imei,
					openDoorType: this.form.openDoorType,
					schoolId: this.form.schoolName
				}
				readerCardAdd(params).then((res) => {
					ElMessage.success('新增成功')
					this.handleClose()
				}).catch((err) => {
					ElMessage.error("修改失败");

				})
			},
			//   修改
			readerCardUpdateXiu() {
				const params = {
					code: this.form.code,
					mobile: this.form.mobile,
					name: this.form.imei,
					openDoorType: this.form.openDoorType,
					schoolId: this.xiugaiObj.schoolId,
				}
				readerCardUpdate(params, this.cardid).then((res) => {
					console.log(res, '2');
					ElMessage.success('修改成功')
					this.handleClose()
				}).catch((err) => {
					ElMessage.error("修改失败");

				})
			},
			onSubmit(formName) {
				console.log(formName);
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.title == '修改读卡器管理') {
							//   console.log('修改',8888);
							this.readerCardUpdateXiu()

						} else if (this.title == '新增读卡器管理') {
							console.log('新增', 8888);
							this.readerCardAdditive()
						}
					} else {
						return false;

					}
				});
			},

		}
	}
</script>
<style scoped lang="scss">
	/deep/ {
		.el-input--small .el-input__wrapper {
			height: 35px;
			line-height: 35px;
			text-align: center;
			width: 280px;
		}

		.el-select__wrapper {
			height: 35px;
			line-height: 35px;
			width: 270px;
		}

		.el-input__inner {
			// width: 10px !important;
		}

		.buttom-box {
			// text-align: center;
			margin-left: 180px;

		}

		.el-form-item--small {
			width: 70% !important;
		}
	}
</style>